import templateUrl from "./app-nav-header.html";

export const navHeaderComponent = {
  templateUrl,

  bindings: {
    homeOptions: "<",
  },

  controller: class HeaderController {
    constructor($state, $transitions, AuthService) {
      "ngInject";

      this.$state = $state;
      this.authService = AuthService;
      this.$transitions = $transitions;
      this.headerLogo = "/./images/logo";
      this.armyLogo = "/./images/army";
      this.navyLogo = "/./images/navy";
      this.airForceLogo = "/./images/air-force";
      this.coastGaurdLogo = "./images/Coast-Gaurd01";
      this.marineCorpsLogo = "/./images/Marine-corps";
    }

    $onInit() {
      this.user = this.authService.getUser();
      this.isCommandCounselor =
        this.user.role && this.user.role === "commandCareerCounselor";
       // this.setRoute();
      this.accountOptions = [
        {
          title: "Change Password",
          value: "changePassword",
        },
      ];
      if (this.isCommandCounselor) {
        this.accountOptions.push({
          title: "Profile",
          value: "profile",
        });
      }
      this.accountOptions.push({
        title: "Logout",
        value: "logout",
      });
      this.displayDropdown = false;
      this.$transitions.onSuccess({}, _onStateChangeSuccess.bind(this));

      function _onStateChangeSuccess() {
        this._setDropdownTitle();
      }
    }

    onLogOut() {
      this.authService.logout().then((result) => {
        this.$state.go("login");
      });
    }
    setRoute(){
      console.log(this.$state.current.breadcrumbName)
      console.log("pa",this.$state.current.parentState)
      if(this.user.role === "commandCareerCounselor"){
        this.stateName = this.$state.current.breadcrumbName;
        if(this.stateName === 'Group view'){
          this.$state.current.parentState = 'home';
        }
        if(this.stateName === 'members list'){
          this.$state.current.parentState = 'commandCounsellorGroupsDetails';
        }
      }else{
        this.stateName = this.$state.current.breadcrumbName;
        if(this.stateName === 'Group view'){
          this.$state.current.parentState = "commandCounsellorGroupsroute";
        }
        // if(this.stateName === 'members list'){
        //   this.$state.current.parentState = 'commandCounsellorGroupsDetails';
        // }
      }
    }

    _setDropdownTitle() {
      if (this.$state.current.name === "home") {
        this.displayDropdown = false;
      } else {
        this.displayDropdown = true;
        //supress the path
        if(this.user.role === "commandCareerCounselor"){
          this.stateName = this.$state.current.breadcrumbName;
          if(this.stateName === 'Group view'){
            this.$state.current.parentState = 'home';
          }
         
        }else{
          // this.stateName = this.$state.current.breadcrumbName;
          // if(this.stateName === 'Group view'){
          //   this.$state.current.parentState = "commandCounsellorGroupsroute";
          // }
        }

        // get home state details
        if (this.$state.current.parentState) {
          let parentStateDetails = this.$state.get(
            this.$state.current.parentState
          );
          // if not parentState available
          // consider the current state breadcrumbName as the title
          if (!parentStateDetails.parentState) {
            if (this.$state.current.title) {
              this.dropdownTitle = this.$state.current.title;
              this.stateName = this.$state.current.breadcrumbName;
            } else {
              this.dropdownTitle = this.$state.current.breadcrumbName;
              this.selectedDropdownTitle = this.$state.current.name;
              this.stateName = this.$state.current.name;
            }
          } else {
            this.dropdownTitle = parentStateDetails.breadcrumbName;
          }
        }
      }
    }

    onFeatureClick(item) {
      this.$state.go(item.route.name);
    }

    onOptionsClick(item) {
      if (item.value === "profile") {
        const user = this.authService.getUser();
        this.$state.go("profileDetail", {
          id: user.accountId,
        });
      } else if (item.value == "logout") {
        this.onLogOut();
      } else if (item.value == "changePassword") {
        this.$state.go("changePassword");
      }
    }

    $onChanges(changes) {
      if (changes && changes.homeOptions && changes.homeOptions.currentValue) {
        this.homeOptions = changes.homeOptions.currentValue;
        this._setDropdownTitle();
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/common/app-nav/app-nav-header.component.js